<div class="mobile-top-bar">
  <div class="logo-container">
    <img class="fullsked-logo" src="assets/img/fullsked-logo-2.svg" alt="FullSked" />
  </div>
  <div class="alert-container">
    <alert-count-display [ngClass]="{'fade-out': menuOpen, 'fade-in': !menuOpen}"></alert-count-display>
  </div>
  <button class="menu-button" (click)="toggleMenuState()">
    <img [ngClass]="{'fade-out': menuOpen, 'fade-in': !menuOpen}" src="assets/img/icons/mobile-menu.svg" alt="Menu" />
    <img
      [ngClass]="{'fade-out': !menuOpen, 'fade-in': menuOpen}"
      src="assets/img/icons/x-light-brown.svg"
      alt="Close Menu"
    />
  </button>
</div>
